<div class="contenedor-footer">
    <a class="link-footer" href="https://grupogestoriapastor.com/">
        © {{year}} Grupo Gestoría Pastor | <img src="assets/img/logo-empresa.png" height="17">
    </a>
</div>
